<template>
    <div class="content-wrapper">
        <div class="d-none">
            <app-breadcrumb :page-title="$t('adverts')" :directory="$t('datatables')" :icon="'grid'" />
        </div>
        <div class="col-sm-6 col-md-6 mb-3 pl-0">
            <br><br>
        </div>

        <app-career-site-editor
                :selectedUrl="selectedUrl"
                :uploadedImage="uploadedImage"
                @getImageAction="getSelectedImagesAction">
        </app-career-site-editor>

        <form-editor-files
                :selectedId="selectedId"
                :selectedAction="selectedAction"
                @getUploadedImage="getUploadedImages">
        </form-editor-files>

    </div>
</template>
<script>
    import * as actions from "../../../../../Config/ApiUrl";

    export default {
        name: "FormInputs",
        data() {
            return {
                selectedUrl: 'admin/app/careersites/1',
                selectedId: 1,
                selectedAction: '',
                uploadedImage: {},
                options: {
                    currentMainTab: 1,
                    mainTabs: [
                        {page: actions.DATATABLE_CAREERS_URL, pageName: this.$t('adverts')},
                        {page: actions.SITE_CAREERS_URL, pageName: this.$t('career_site')},
                    ],
                },

            }
        },
        created() {
            this.selectedUrl = 'admin/app/careersites/1';
            this.selectedId = 1;
        },
        methods: {
            getSelectedImagesAction(place) {
                console.log('click! '+place);
                this.selectedAction = place;
            },
            getUploadedImages(response) {
                console.log('uploaded!'+response);
                this.uploadedImage = response;
                this.selectedAction = ''; // Hide modal
            },
        },
    }
</script>
